import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { UserPlus, Search, User, Loader2, Users } from "lucide-react";
import api from "../../services/api";

export default function AdminReferralModal({ open, onClose, onCreated }) {
  var modeState = useState("client");
  var mode = modeState[0];
  var setMode = modeState[1];

  var clientsState = useState([]);
  var searchState = useState("");
  var selectedClientState = useState(null);
  var freeNameState = useState("");
  var loadingClientsState = useState(false);

  var formState = useState({ name: "", phone: "", email: "", product_interest: "", notes: "" });
  var form = formState[0];
  var savingState = useState(false);
  var errorState = useState(null);

  useEffect(function() {
    if (!open) return;
    loadingClientsState[1](true);
    api.get("/clients?limit=200").then(function(r) {
      clientsState[1](r.data.clients || []);
    }).catch(function() {}).finally(function() { loadingClientsState[1](false); });
  }, [open]);

  function handleChange(field, value) {
    formState[1](function(prev) { var n = Object.assign({}, prev); n[field] = value; return n; });
  }

  var filtered = clientsState[0].filter(function(c) {
    if (!searchState[0]) return true;
    var q = searchState[0].toLowerCase();
    return (c.name || "").toLowerCase().includes(q) || (c.email || "").toLowerCase().includes(q);
  });

  async function handleSave() {
    if (!form.name || !form.phone) { errorState[1]("Nome e telefone do indicado sao obrigatorios"); return; }
    if (mode === "client" && !selectedClientState[0]) { errorState[1]("Selecione um cliente da base"); return; }
    if (mode === "free" && !freeNameState[0].trim()) { errorState[1]("Informe o nome de quem indicou"); return; }

    savingState[1](true);
    errorState[1](null);
    try {
      var payload = {
        name: form.name,
        phone: form.phone,
        email: form.email,
        product_interest: form.product_interest,
        notes: form.notes,
      };
      if (mode === "client") {
        payload.referred_by_client_id = selectedClientState[0].id;
      } else {
        payload.referred_by_name = freeNameState[0].trim();
      }
      await api.post("/referrals/admin-create", payload);
      onCreated();
    } catch (err) {
      errorState[1](err.response?.data?.detail || "Erro ao criar indicacao");
    } finally {
      savingState[1](false);
    }
  }

  function handleClose() {
    formState[1]({ name: "", phone: "", email: "", product_interest: "", notes: "" });
    selectedClientState[1](null);
    freeNameState[1]("");
    searchState[1]("");
    errorState[1](null);
    onClose();
  }

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-[#0A2F3D]">
            <UserPlus className="w-5 h-5 text-purple-500" />Nova Indicacao
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 mt-2" data-testid="admin-referral-modal">
          {/* Mode selector */}
          <div>
            <label className="text-xs font-medium text-gray-500 mb-2 block">Quem indicou?</label>
            <div className="flex gap-2">
              <button onClick={function() { setMode("client"); }} data-testid="referral-mode-client"
                className={"flex-1 px-3 py-2 rounded-xl text-xs font-medium border transition-colors flex items-center justify-center gap-1.5 " + (mode === "client" ? "bg-purple-50 border-purple-200 text-purple-700" : "bg-white border-gray-200 text-gray-500 hover:border-gray-300")}>
                <User className="w-3.5 h-3.5" />Cliente da Base
              </button>
              <button onClick={function() { setMode("free"); }} data-testid="referral-mode-free"
                className={"flex-1 px-3 py-2 rounded-xl text-xs font-medium border transition-colors flex items-center justify-center gap-1.5 " + (mode === "free" ? "bg-amber-50 border-amber-200 text-amber-700" : "bg-white border-gray-200 text-gray-500 hover:border-gray-300")}>
                <Users className="w-3.5 h-3.5" />Parceiro / Outro
              </button>
            </div>
          </div>

          {/* Client selector or free name */}
          {mode === "client" ? (
            <div>
              <div className="relative mb-2">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
                <input type="text" value={searchState[0]} onChange={function(e) { searchState[1](e.target.value); }}
                  placeholder="Buscar cliente por nome ou email..."
                  className="w-full pl-9 pr-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-400/40"
                  data-testid="referral-client-search" />
              </div>
              <div className="max-h-32 overflow-y-auto border border-gray-200 rounded-xl">
                {loadingClientsState[0] ? (
                  <div className="flex justify-center py-4"><Loader2 className="w-4 h-4 animate-spin text-gray-400" /></div>
                ) : filtered.length === 0 ? (
                  <p className="text-xs text-gray-400 text-center py-4">Nenhum cliente encontrado</p>
                ) : (
                  filtered.slice(0, 30).map(function(c) {
                    var sel = selectedClientState[0] && selectedClientState[0].id === c.id;
                    return (
                      <div key={c.id} onClick={function() { selectedClientState[1](c); }}
                        className={"px-3 py-2 cursor-pointer border-b border-gray-50 last:border-0 text-sm transition-colors " + (sel ? "bg-purple-50" : "hover:bg-gray-50")}
                        data-testid={"referral-client-" + c.id}>
                        <span className="font-medium text-[#0A2F3D]">{c.name}</span>
                        <span className="text-xs text-gray-400 ml-2">{c.email}</span>
                      </div>
                    );
                  })
                )}
              </div>
              {selectedClientState[0] && (
                <p className="text-xs text-purple-600 mt-1">Selecionado: <strong>{selectedClientState[0].name}</strong> — indicacao contabilizada no perfil</p>
              )}
            </div>
          ) : (
            <div>
              <label className="text-xs font-medium text-gray-500 mb-1 block">Nome de quem indicou</label>
              <input type="text" value={freeNameState[0]} onChange={function(e) { freeNameState[1](e.target.value); }}
                placeholder="Ex: João (parceiro), Maria (parente)..."
                className="w-full px-3 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-amber-400/40"
                data-testid="referral-free-name" />
              <p className="text-xs text-gray-400 mt-1">Nao sera vinculado a nenhum cliente da base</p>
            </div>
          )}

          <hr className="border-gray-100" />

          {/* Referred person data */}
          <p className="text-xs font-semibold text-gray-600 uppercase tracking-wide">Dados do Indicado</p>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs font-medium text-gray-500 mb-1 block">Nome *</label>
              <input type="text" value={form.name} onChange={function(e) { handleChange("name", e.target.value); }}
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-400/40"
                placeholder="Nome completo" data-testid="referral-form-name" />
            </div>
            <div>
              <label className="text-xs font-medium text-gray-500 mb-1 block">Telefone *</label>
              <input type="tel" value={form.phone} onChange={function(e) { handleChange("phone", e.target.value); }}
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-400/40"
                placeholder="(11) 99999-9999" data-testid="referral-form-phone" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs font-medium text-gray-500 mb-1 block">Email</label>
              <input type="email" value={form.email} onChange={function(e) { handleChange("email", e.target.value); }}
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-400/40"
                placeholder="email@exemplo.com" data-testid="referral-form-email" />
            </div>
            <div>
              <label className="text-xs font-medium text-gray-500 mb-1 block">Interesse</label>
              <select value={form.product_interest} onChange={function(e) { handleChange("product_interest", e.target.value); }}
                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm bg-white focus:outline-none focus:ring-2 focus:ring-purple-400/40"
                data-testid="referral-form-interest">
                <option value="">Selecionar...</option>
                <option value="consorcio">Consorcio</option>
                <option value="seguro">Seguro</option>
                <option value="plano_saude">Plano de Saude</option>
              </select>
            </div>
          </div>
          <div>
            <label className="text-xs font-medium text-gray-500 mb-1 block">Observacao</label>
            <textarea value={form.notes} onChange={function(e) { handleChange("notes", e.target.value); }}
              className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-purple-400/40 resize-none"
              rows={2} placeholder="Detalhes sobre a indicacao..." data-testid="referral-form-notes" />
          </div>

          {errorState[0] && <p className="text-xs text-red-600 bg-red-50 px-3 py-2 rounded-lg">{errorState[0]}</p>}

          <div className="flex justify-end gap-2 pt-2 border-t border-gray-100">
            <button onClick={handleClose} className="px-4 py-2 text-xs font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg">Cancelar</button>
            <button onClick={handleSave} disabled={savingState[0]}
              className="px-4 py-2 text-xs font-medium text-white bg-purple-600 hover:bg-purple-700 rounded-lg flex items-center gap-1.5 disabled:opacity-50"
              data-testid="referral-form-submit">
              {savingState[0] ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <UserPlus className="w-3.5 h-3.5" />}Cadastrar Indicacao
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
